import { LoginCard } from '@/components/auth/login-card';
import { resetAuthGuardCache } from '@/lib/auth-guard';
import { resetSessionExpiry } from '@/lib/session-expiry';
import { createFileRoute, useNavigate } from '@tanstack/react-router';

type LoginSearch = {
  redirect?: string;
  reason?: 'expired';
};

export const Route = createFileRoute('/login')({
  validateSearch: (search: Record<string, unknown>): LoginSearch => {
    const redirect = typeof search.redirect === 'string' ? search.redirect : undefined;
    const reason = search.reason === 'expired' ? 'expired' : undefined;
    return {
      ...(redirect !== undefined ? { redirect } : {}),
      ...(reason !== undefined ? { reason } : {}),
    };
  },
  component: LoginPage,
});

const SESSION_EXPIRED_MESSAGE = 'Votre session a expiré. Reconnectez-vous pour continuer.';

function LoginPage() {
  const navigate = useNavigate();
  const { redirect, reason } = Route.useSearch();

  function handleSuccess() {
    // The boot status was cached before login; clear it so guarded routes
    // re-resolve (the token is now present, so they'll pass synchronously).
    resetAuthGuardCache();
    resetSessionExpiry();
    if (redirect?.startsWith('/') && !redirect.startsWith('/login')) {
      void navigate({ to: redirect });
    } else {
      void navigate({ to: '/words' });
    }
  }

  return (
    <div className="login-stage">
      <main className="login-stage__inner">
        <LoginCard
          onSuccess={handleSuccess}
          {...(reason === 'expired' ? { initialMessage: SESSION_EXPIRED_MESSAGE } : {})}
        />
        <p className="login-help">
          besoin d’aide ? {/* Stub: contacting the admin is not wired up yet. */}
          <button type="button" className="login-help__link" onClick={() => undefined}>
            contactez votre administrateur
          </button>
        </p>
      </main>
    </div>
  );
}
